import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import { GADataProps } from "@components/GAData/GAData";
import EventsAwardsHeader from "@events-awards/components/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/components/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import LandingPageArticle from "@events-awards/components/LandingPageArticle";
import {
  AwardType,
  EventsAwardsLandingPageData,
} from "@events-awards/utils/types";
import { useInjectClientData } from "@hooks/useInjectClientData";
import SIADescription from "@sia/components/SIADescription";
import SIAFooter from "@sia/components/SIAFooterComponents/SIAFooter";
import SIAJudgingPanel from "@sia/components/SIAJudgingPanel";
import SIANominationsDescription from "@sia/components/SIANominationsDescription";
import SIAOrganiserDetails from "@sia/components/SIAOrganizerDetails";

/**
 * Component to render event and awards page
 */
const EventsAwardsSIAPageContent = ({
  articleProps,
  gaProps,
}: EventsAwardsLandingPageData & {
  gaProps: GADataProps;
}): React.ReactElement => {
  useInjectClientData({ gaProps });

  return (
    <div
      className="w-full"
      data-testid="events-awards-sia-page-content-component"
    >
      <EventsAwardsHeader />

      <Container>
        <EventsAwardsNavigationBar awardType={AwardType.SIA} />
      </Container>

      {articleProps ? (
        <div className="mb-6 bg-gray-150">
          <Container rootClassName="px-0 lg:px-3">
            <LandingPageArticle articleProps={articleProps} />
          </Container>
        </div>
      ) : null}

      <SIADescription />

      <div className="mt-1 bg-gray-150 py-9 md:px-6 lg:px-0">
        <Container rootClassName="flex flex-row justify-center items-center">
          <SIANominationsDescription />
        </Container>
      </div>

      <SIAOrganiserDetails />

      <SIAJudgingPanel />

      <SIAFooter />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EventsAwardsSIAPageContent;
